jQuery( document ).ready(function() {

	jQuery( ".fabrication-container .fabrication-item" ).each(function( index ) {

		const range = [0, 5];
		const value = index;
		const normal = norm(value, range[0], range[1]); // Return 0.15

		function norm(value, min, max) {
			return (value - min) / (max - min);
		}

		jQuery(this).append("<div class=" + "card" + "></div>");

		jQuery(".card").each(function (index){
			jQuery(this).attr('id', index );
		});

		jQuery(".fabrication-item").each(function (index){
			jQuery(this).attr('id', "fabrication-"+index );
		});


		var cardAnimation = {
			container: document.getElementById(index), // the dom element that will contain the animation
			renderer: 'svg',
			loop: true,
			autoplay: false,
			name: "cardAnim",
			path: '/wp-content/themes/millwrightprojects/assets/anim/'+index+'.json' // the path to the animation json
		}

		lottie.loadAnimation(cardAnimation);

		jQuery(this).hover(function(){
			lottie.play("cardAnim");

		},
		function() {
			lottie.stop("cardAnim");
		});

	});

});